const SecuritySuggestions = () => (
  <div>
    <h2>Güvenlik Önerileri</h2>
    <ul>
      <li>Gayrimenkul hakkında gerekli bilgiyi edindikten sonra görmeye gidin.</li>
      <li>Tanımadığınız şahışlara kesinlikle para göndermeyin.</li>
      <li>TC kimlik numarası veya cep telefonu vasıtasıyla yapılması istenen para transferlerini yapmayın.</li>
      <li>Satın alacağınız veya kiralayacağınız gayrimenkulu görmeden kesinlikle kapora vermeyin.</li>
      <li>Yaptığınız her ödemenin dekontunu veya ödemeyle ilgili belgeyi mutlaka saklayın.</li>
      <li>Satış veya kiralama sözleşmesinin her maddesini dikkatlice okuyun.</li>
      <li>
        Ödeme yaptığınız halde satın alma / kiralama sürecinde sorun yaşamanız durumunda, emlakjet.com&apos;un hiçbir
        hukuki sorumluluğu bulunmamaktadır.
      </li>
    </ul>
  </div>
);

export default SecuritySuggestions;
